<template>
  <div>
    <div class="columns">
      <div class="column">
        <b-field
          id="identification-id"
          :label="form.typeOfCard === 'Passport' ? $t('kyc.passport') : form.typeOfCard === 'ID Card' ? $t('kyc.id_card'): $t('kyc.id_card_passport')"
        >
          <b-input
            v-validate="'required|isThaiIdCard'"
            v-if="form.nationality === 'Thai' && form.typeOfCard === 'ID Card'"
            v-model="form.identificationId"
            :placeholder="$t('kyc.id_card_placeholder')"
            name="identification id"
            autocomplete="disabled"
            data-test="kyc-identify--identification-id-field"
            @blur="$emit('trackInputForm', { key: 'identificationId', name: 'identification id', page: 'Indentify' })"
          />
          <b-input
            v-validate="{required: true, max:10}"
            v-else
            v-model="form.identificationId"
            :placeholder="$t('kyc.id_card_placeholder')"
            name="identification id"
            autocomplete="disabled"
            data-test="kyc-identify--identification-id-field"
            @blur="$emit('trackInputForm', { key: 'identificationId', name: 'identification id', page: 'Indentify' })"
          />
        </b-field>
        <span class="is-invalid">{{ errors.first('identification id') }}</span>
      </div>
    </div>
    <div
      v-if="form.typeOfCard === 'ID Card' && form.nationality === 'Thai'"
      class="columns"
    >
      <div class="column">
        <b-field
          id="laser-code"
          :label="$t('kyc.laser_code')"
        >
          <b-input
            v-validate="'required|isLaserCode'"
            v-model="form.laserCode"
            :placeholder="$t('kyc.laser_code_placeholder')"
            name="laser code"
            autocomplete="disabled"
            data-test="kyc-identify--laser-code-field"
            @blur="$emit('trackInputForm', { key: 'laserCode', name: 'laser code', page: 'Indentify' })"
          />
        </b-field>
        <span class="is-invalid">{{ errors.first('laser code') }}</span>
        <div
          class="example-text"
          style="text-align: left;"
          @click="isExLaserCodeModalActive = true"
        >
          {{ $t('kyc.ex_laser_code') }}
        </div>
        <b-modal :active.sync="isExLaserCodeModalActive">
          <p class="image example-img-modal">
            <img src="/static/img/laser-code-example.png">
          </p>
        </b-modal>
      </div>
    </div>
    <div class="columns is-desktop">
      <div class="column">
        <b-field
          id="date-of-issue"
          :label="$t('kyc.date_of_issue')"
          data-test="kyc-identify--date-of-issue-field"
        >
          <b-datepicker
            v-validate="'required|dateBeforeNow'"
            v-model="form.issueDateOfId"
            :mobile-native="false"
            :years-range="[-200, 200]"
            :placeholder="$t('kyc.click_to_select')"
            icon="calendar-today"
            name="date of issue"
            @input="$emit('trackInputForm', { key: 'issueDateOfId', name: 'date of issue', page: 'Indentify' })"
          />
        </b-field>
        <span class="is-invalid">{{ errors.first('date of issue') }}</span>
      </div>
      <div class="column">
        <b-field
          id="date-of-expire"
          :label="$t('kyc.date_of_exp')"
          data-test="kyc-identify--date-of-expire-field"
        >
          <b-datepicker
            v-validate="{required: !form.isLifetime , dateAfterNow: !form.isLifetime }"
            v-model="form.expireDateOfId"
            :disabled="Boolean(form.isLifetime)"
            :mobile-native="false"
            :years-range="[-200, 200]"
            :placeholder="$t('kyc.click_to_select')"
            icon="calendar-today"
            name="date of expire"
            @input="$emit('trackInputForm', { key: 'expireDateOfId', name: 'date of expire', page: 'Indentify' })"
          />
        </b-field>
        <span class="is-invalid">{{ errors.first('date of expire') }}</span>
        <b-field
          v-if="form.typeOfCard === 'ID Card'"
          data-test="kyc-identify--lifetime-checkbox"
        >
          <b-checkbox
            v-model="form.isLifetime"
            :false-value="false"
            :true-value="$t('kyc.life_time_id_card')"
            name="Lifetime"

            @click.native="$emit('trackInputForm', { key: 'isLifetime', name: 'Lifetime', page: 'Indentify' })"
          >
            {{ $t('kyc.life_time_id_card') }}
          </b-checkbox>
        </b-field>
      </div>
    </div>
    <div class="columns mg-t-20px">
      <div class="column document-box">
        <div
          id="id-card-photo"
          class="strong-text"
        >
          {{ $t('kyc.upload_id_card', { typeOfCard: form.typeOfCard === 'Passport' ? $t('kyc.passport') : $t('kyc.id_card') }) }}
        </div>
        <div class="pale-text">
          ({{ $t('kyc.max_file_type', [limitFileSizeInMb]) }})
        </div>
        <div class="example-img">
          <b-upload
            v-validate="'required'"
            v-model="form.inputFileIdCard"
            name="ID card photo"
            accept="image/*"
            drag-drop
            @input="onUploadIdPicChange"
          >
            <section
              class="section"
              data-test="kyc-identify--id-card-upload"
            >
              <div class="content has-text-centered">
                <img
                  :src="form.identificationPicture || '/static/img/front-id-card.png'"
                  class="dropzone-img"
                >
              </div>
              <div class="browse-btn">
                {{ $t('kyc.browse') }}
              </div>
            </section>
          </b-upload>
          <span class="is-invalid">{{ errors.first('ID card photo') }}</span>
        </div>
        <div
          class="example-text"
          @click="isExIdCardModalActive = true"
        >
          {{ $t('kyc.ex_id_card', { typeOfCard: form.typeOfCard === 'Passport' ? $t('kyc.passport') : $t('kyc.id_card') }) }}
        </div>
        <div
          v-if="isIdImageOverSize"
          class="is-invalid t-al-center"
        >
          {{ $t('messages.img_size_must_less_than', [limitFileSizeInMb]) }}
        </div>
        <b-modal :active.sync="isExIdCardModalActive">
          <p class="image example-img-modal">
            <img
              v-if="form.typeOfCard === 'Passport'"
              src="/static/img/ex-passport.png"
            >
            <img
              v-else
              src="/static/img/ex-front-id-card.png"
            >
          </p>
        </b-modal>
      </div>
    </div>
    <div class="columns mg-t-20px">
      <div class="column document-box">
        <div
          id="selfie-photo"
          class="strong-text"
        >
          {{ $t('kyc.upload_selfie') }}
        </div>
        <div class="example-img">
          <b-upload
            v-validate="'required'"
            v-model="form.inputFileSelfie"
            name="Selfie photo"
            accept="image/*"
            drag-drop
            @input="onUploadSelfiePicChange"
          >
            <section
              class="section"
              data-test="kyc-identify--selfie-id-card-upload"
            >
              <div class="content has-text-centered">
                <img
                  :src="form.selfIdentificationPicture || '/static/img/selfie-id-card.png'"
                  class="dropzone-img"
                >
              </div>
              <div class="browse-btn">
                {{ $t('kyc.browse') }}
              </div>
            </section>
          </b-upload>
          <span class="is-invalid">{{ errors.first('Selfie photo') }}</span>
        </div>
        <div
          class="example-text"
          @click="isExSelfieModalActive = true"
        >
          {{ $t('kyc.ex_selfie') }}
        </div>
        <div
          v-if="isSelfImageOverSize"
          class="is-invalid t-al-center"
        >
          {{ $t('messages.img_size_must_less_than', [limitFileSizeInMb]) }}
        </div>
        <b-modal :active.sync="isExSelfieModalActive">
          <p class="image example-img-modal">
            <img src="/static/img/ex-selfie-id-card.jpg">
          </p>
        </b-modal>
        <div class="column upload-selfie-detail">
          <ul>
            <li v-html="$t('kyc.detail_selfie.l1')"/>
            <li v-html="$t('kyc.detail_selfie.l2', { typeOfCard: form.typeOfCard === 'Passport' ? $t('kyc.passport') : $t('kyc.id_card') })"/>
            <li v-html="$t('kyc.detail_selfie.l3')"/>
            <li v-html="$t('kyc.detail_selfie.l4')"/>
            <li v-html="$t('kyc.detail_selfie.l5')"/>
          </ul>
        </div>
        <div
          id="government-issued"
          class="strong-text"
        >
          {{ $t('kyc.upload_gov_issued') }}
        </div>
        <div class="example-img">
          <b-upload
            v-validate="'required'"
            v-model="form.governmentIssued"
            name="government issued"
            accept="image/*,.pdf"
            drag-drop
            @input="(file) => onUploadDoc(file, 'governmentIssued')"
          >
            <section
              class="section"
              data-test="kyc-identify--government-issued-upload"
            >
              <div class="content has-text-centered">
                <img
                  src="/static/img/icon-company-cer-doc.png"
                  class="dropzone-img--goverment-issued"
                >
              </div>
              <div class="browse-btn">
                {{ $t('kyc.browse_file') }}
              </div>
            </section>
          </b-upload>
          <span class="is-invalid">{{ errors.first('government issued') }}</span>
          <b-tag
            v-if="form.governmentIssued"
            type="is-primary"
          >
            {{ form.governmentIssued.name }}
          </b-tag>
          <div
            v-if="isGovernmentIssuedOverSize"
            class="is-invalid t-al-center"
          >
            {{ $t('kyc.doc_limit') }} {{ limitFileSizeInMb }} MB
          </div>
        </div>
      </div>
    </div>
    <!-- Upload Organization Documents -->
    <UploadOrgDocument
      v-if="form.customerType === 'Organization'"
      :form.sync="form"
    />
    <!-- FACTA -->
    <p class="facta title">{{ $t('kyc.facta_title') }}</p>
    <p
      class="facta subtitle"
      v-html="$t('kyc.facta_sub_title')"
    />
    <div class="columns">
      <div class="column">
        <b-field
          id="is-american"
          :label="$t('kyc.is_american')"
        >
          <div data-test="kyc-identify--is-american-radio">
            <b-radio
              v-validate="'required'"
              v-model="form.isAmerican"
              :native-value="true"
              name="is american"
              @click.native="$emit('trackInputForm', { key: 'isAmerican', name: 'is American', page: 'Indentify' })"
            >
              {{ $t('kyc.say_yes') }}
            </b-radio>
            <b-radio
              v-validate="'required'"
              v-model="form.isAmerican"
              :native-value="false"
              name="is american"
              @click.native="$emit('trackInputForm', { key: 'isAmerican', name: 'is American', page: 'Indentify' })"
            >
              {{ $t('kyc.say_no') }}
            </b-radio>
          </div>
        </b-field>
        <span class="is-invalid">{{ errors.first('is american') }}</span>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <b-field
          id="is-american-for-pay-tax"
          :label="$t('kyc.is_american_for_pay_tax')"
        >
          <div data-test="kyc-identify--is-american-for-pay-tax-radio">
            <b-radio
              v-validate="'required'"
              v-model="form.isAmericanForPayTax"
              :native-value="true"
              name="is american for pay tax"
              @click.native="$emit('trackInputForm', { key: 'isAmericanForPayTax', name: 'is american for pay tax', page: 'Indentify' })"
            >
              {{ $t('kyc.say_yes') }}
            </b-radio>
            <b-radio
              v-validate="'required'"
              v-model="form.isAmericanForPayTax"
              :native-value="false"
              name="is american for pay tax"
              @click.native="$emit('trackInputForm', { key: 'isAmericanForPayTax', name: 'is american for pay tax', page: 'Indentify' })"
            >
              {{ $t('kyc.say_no') }}
            </b-radio>
          </div>
        </b-field>
        <span class="is-invalid">{{ errors.first('is american for pay tax') }}</span>
      </div>
    </div>
    <div
      v-if="isDisplayAmericanTaxId"
      class="columns"
    >
      <div class="column">
        <b-field
          id="american-tax-id"
          :label="$t('kyc.american_tax_id')"
        >
          <b-input
            v-validate="'required'"
            v-model="form.americanTaxId"
            :placeholder="$t('kyc.american_tax_id_placeholder')"
            name="american tax id"
            autocomplete="disabled"
            data-test="kyc-identify--american-tax-id-field"
            @blur="$emit('trackInputForm', { key: 'americanTaxId', name: 'american tax id', page: 'Indentify' })"
          />
        </b-field>
        <span class="is-invalid">{{ errors.first('american tax id') }}</span>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <p class="label">
          {{ $t('kyc.terms') }}
        </p>
      </div>
    </div>
    <div class="columns mg-t-20px">
      <div
        ref="terms-box"
        class="column scroll-box"
        data-test="kyc-identify--scroll-box"
      >
        <TermsAndConditions/>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <p class="information-disclosure">
          {{ $t('kyc.info_disclosure') }}
        </p>
        <b-field id="terms-and-conditions">
          <div data-test="kyc-identify--is-accept-term-checkbox">
            <b-checkbox
              v-validate="'required:false'"
              v-model="form.isAcceptTermAndPolicy"
              :disabled="isActiveAcceptCheckbox"
              name="Terms and Conditions"
              @click.native="$emit('trackInputForm', { key: 'isAcceptTermAndPolicy', name: 'Terms and Conditions', page: 'Indentify' })"
            >
              {{ $t('kyc.i_agree_terms') }}
            </b-checkbox>
          </div>
        </b-field>
        <span class="is-invalid">{{ errors.first('Terms and Conditions') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { getBase64, resizeImage } from '@/utils/helper'
import { KYC_PICTURE_FILE_SIZE_LIMIT_IN_MB } from '@/constants'
import TermsAndConditions from '@/components/TermsAndConditions'
import UploadOrgDocument from './Organization/UploadOrgDocument'

export default {
  name: 'Identify',
  inject: ['$validator'],
  components: {
    TermsAndConditions,
    UploadOrgDocument
  },
  props: {
    form: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      isExLaserCodeModalActive: false,
      isExIdCardModalActive: false,
      isExSelfieModalActive: false,
      isIdImageOverSize: false,
      isSelfImageOverSize: false,
      isGovernmentIssuedOverSize: false,
      limitFileSizeInMb: KYC_PICTURE_FILE_SIZE_LIMIT_IN_MB,
      isActiveAcceptCheckbox: true
    }
  },
  computed: {
    isDisplayAmericanTaxId () {
      if (this.form.isAmerican || this.form.isAmericanForPayTax) {
        return true
      }
      return false
    }
  },
  watch: {
    form: {
      handler: function (newVal, oldVal) {
        if (newVal.typeOfCard === 'Passport') {
          this.form.isLifetime = false
        }
      },
      deep: true
    },
    isDisplayAmericanTaxId (newVal, oldVal) {
      if (newVal !== oldVal) {
        delete this.form.americanTaxId
      }
    }
  },
  created () {
    if (this.form.isAcceptTermAndPolicy) {
      this.isActiveAcceptCheckbox = false
    }
    if (this.form.nationality === 'Thai') {
      this.form.typeOfCard = 'ID Card'
    } else {
      this.form.typeOfCard = 'Passport'
    }
  },
  mounted () {
    this.$refs['terms-box'].addEventListener('scroll', this.catchScroll)
  },
  destroyed () {
    this.$refs['terms-box'].removeEventListener('scroll', this.catchScroll)
  },
  beforeDestroy () {
    this.$validator.pause()
  },
  methods: {
    openLinkNewTab (name) {
      const routeData = this.$router.resolve({ name })
      window.open(routeData.href, '_blank')
    },
    async onUploadIdPicChange (file) {
      if ((file.size / 1000000) > KYC_PICTURE_FILE_SIZE_LIMIT_IN_MB) {
        this.isIdImageOverSize = true
        this.form.identificationPicture = null
        return
      }
      this.isIdImageOverSize = false
      const base64 = await getBase64(file)
      const image = await resizeImage(base64)

      this.form.identificationPicture = image
      this.$emit('trackInputForm', {key: 'identificationPicture', name: 'ID card photo', page: 'Indentify'})
      this.$forceUpdate() // Force re-render
    },
    async onUploadSelfiePicChange (file) {
      if ((file.size / 1000000) > KYC_PICTURE_FILE_SIZE_LIMIT_IN_MB) {
        this.isSelfImageOverSize = true
        this.form.selfIdentificationPicture = null
        return
      }
      this.isSelfImageOverSize = false
      const base64 = await getBase64(file)
      const image = await resizeImage(base64)
      this.form.selfIdentificationPicture = image
      this.$emit('trackInputForm', {key: 'selfIdentificationPicture', name: 'Selfie photo', page: 'Indentify'})
      this.$forceUpdate() // Force re-render
    },
    async onUploadDoc (file, key) {
      this[`${key}OverSize`] = false
      if ((file.size / 1000000) > this.limitFileSizeInMb) {
        this[`${key}OverSize`] = true
        this.form[key] = null
      }
    },
    catchScroll () {
      const minPercentageToActiveAccept = this.$refs['terms-box'].clientHeight * 1.5
      if (this.$refs['terms-box'].scrollHeight - this.$refs['terms-box'].scrollTop <= minPercentageToActiveAccept) {
        this.isActiveAcceptCheckbox = false
      }
    }
  }
}
</script>

<style lang="scss">
.kyc-id-passport-is-expanded {
  .control {
    .select {
      width: 100%;
      select {
        width: 100%;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.document-box {
  width: 100%;
  max-width: 75%;
  margin: 0 auto;
}
.strong-text {
  font-size: 15px;
  font-weight: bold;
  letter-spacing: 0.3px;
  color: #000000;
  margin-top: 30px;
}
.pale-text {
  font-size: 15px;
  font-weight: 500;
  line-height: 1.67;
  letter-spacing: 0.37px;
  color: #939393;
  margin-top: 5px;
}
.example-img {
  text-align: center;
  margin-top: 20px;
}
.example-img-modal {
  width: 80%;
  margin: auto;
}
.dropzone-img {
  max-width: 350px;
  width: 100%;

  &--goverment-issued {
    max-width: 173px;
    width: 100%;
  }
}
.browse-btn {
  border-radius: 3px;
  background-color: #069bf9;
  max-width: 250px;
  padding: 13px;
  color: #fff;
  font-size: 15px;
  font-weight: bold;
  letter-spacing: 0.37px;
  margin: 0 auto;
  text-align: center;
  cursor: pointer;
  margin-top: 20px;
}
.example-text {
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 0.37px;
  color: #0559af;
  text-decoration: underline;
  margin: 0 auto;
  text-align: center;
  cursor: pointer;
  margin-top: 20px;
  font-weight: bold;
}
.mg-t-20px {
  margin-top: 20px;
}
.t-al-center {
  text-align: center;
}
.scroll-box {
  overflow-y: scroll;
  height: 600px;
  border: #363636 solid 1px;
}
.information-disclosure {
  font-weight: bold;
  margin: 20px auto;
  display: block;
}
.upload-selfie-detail {
  margin-top: 15px;
  line-height: 2;
  ul {
    list-style-type: disc;
  }
}
.facta {
  &.title {
    font-weight: bold;
    font-size: 1rem;
    margin: 28px 0 34px;
  }
  &.subtitle {
    font-size: 15px;
    line-height: 1.5;
  }
}
/* Mobile */
@media only screen and (max-width: 768px) {
  .document-box {
    max-width: 95%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/KYC/components/Identify.vue